import React from 'react';

const EyeIcon = () => {
	return (
		<svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<g>
				<path d='M12.5 9.58203C12.5 10.9987 11.4167 12.082 10 12.082C8.58337 12.082 7.50004 10.9987 7.50004 9.58203C7.50004 8.16536 8.58337 7.08203 10 7.08203C11.4167 7.08203 12.5 8.16536 12.5 9.58203ZM19.1667 9.58203C19.1667 9.91536 19.0834 10.332 18.8334 10.582C17.5 12.332 14.5834 15.832 10 15.832C5.41671 15.832 2.50004 12.332 1.16671 10.582C0.916707 10.332 0.833374 9.91536 0.833374 9.58203C0.833374 9.2487 0.916707 8.83203 1.16671 8.58203C2.50004 6.83203 5.41671 3.33203 10 3.33203C14.5834 3.33203 17.5 6.83203 18.8334 8.58203C19.0834 8.83203 19.1667 9.2487 19.1667 9.58203ZM14.1667 9.58203C14.1667 7.2487 12.3334 5.41536 10 5.41536C7.66671 5.41536 5.83337 7.2487 5.83337 9.58203C5.83337 11.9154 7.66671 13.7487 10 13.7487C12.3334 13.7487 14.1667 11.9154 14.1667 9.58203Z' />
			</g>
		</svg>
	);
};

export default EyeIcon;
